<template>
  <div>{{$t('view_logout_index_52')}}</div>

</template>

<script>
import i18n from '../../language/index'

    export default {
        name: "logout",
      mounted(){
        //首次加载，等到首屏数据加载完毕，删除蒙层
        if ($('.init_mongolia_layer').length > 0) {
          $('.init_mongolia_layer').remove();
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/logout/index.vue